import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import _ from 'lodash';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Spinner,
  UncontrolledTooltip,
  TabPane,
  CardFooter,
} from 'reactstrap';
import PageTabs from 'components/PageTabs';
import { FixedCenterLoader } from 'components/Loaders';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import { AutoColumns } from 'components/Columns';
import { useArrayState } from 'components/CustomHooks';
import DownloadSimpleTable from 'components/DownloadSimpleTable';
import ReactDatetime from 'react-datetime';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { getRiskLabRiskLabFactorLens } from 'services/analysis';
import { optionizeValue, optionizeAll, getValue, getDate, getYearMonth, monthDiff } from 'helpers/select';
import { confidenceLevelToInterval } from 'helpers/formatter';
import { toDeci, toPerc, toPercTable, toDeciTable, tablePresets, getDataType, formatCurrency } from 'helpers/formatter';
import PieChart from 'components/PieChart';
import TightTable from 'components/TightTable';
import { Descriptions, Notes } from '../others';
import AssetSelect from '../AssetSelect';
import RiskLabFactorLensBase from './factor-lens/FactorLens';
import SingleAssetHeader from 'views/SingleAssetHeader';
import ToggleContainer from 'components/ToggleContainer';

function RiskLabFactorLens({ session }) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({
    product: '',
    database: '',
    benchmark: '',
    single_factor_choice: '',
    converter: '',
  });
  const [result, setResult] = useState(null);

  const fetchData = async () => {
    setLoading(true);

    const [data] = await getRiskLabRiskLabFactorLens(options);

    setResult(data);
    setLoading(false);
  };

  useEffect(() => {
    if (!options.product) return;
    fetchData();
  }, [options]);

  let main = null;
  if (loading) {
    main = <FixedCenterLoader />;
  } else if (result) {
    main = (
      <>
        <SingleAssetHeader data={result.header} />
        <Descriptions content={result.description} />
        <RiskLabFactorLensBase data={result.single_factor_tab} params={options} />
        <Notes content={result.notes} />
      </>
    );
  }

  const sideMenu = (
    <AssetSelect
      session={session}
      onSelect={({ product, database, benchmark, factor, converter }) => {
        setOptions({ product, database, benchmark, single_factor_choice: factor, converter });
      }}
      enableFactor
      enableBenchmark
    />
  );

  const mainContent = <div key={options.product}>{main}</div>;

  return (
    <ToggleContainer
      sideMenu={sideMenu}
      mainContent={options.product && mainContent}
      classNames={{ sideMenu: 'tw-w-[400px]' }}
    />
  );
}

export default RiskLabFactorLens;
